import { BlockProductFeedEntityHydrated, EntityId } from "@jackfruit/common"
import React from "react"
import { useLocation } from "react-use"
import Wrapper from "~/components/Wrapper"
import { useForceCanonicalForPage } from "~/hooks/useForceCanonicalForPage"
import { useProductFeedBlock } from "~/hooks/useProductFeedBlock"
import { useBootstrapProductFeed } from "./hooks/useBootstrapProductFeed"
import ProductFeedContent from "./ProductFeedContent"
import ProductFeedNotFound from "./ProductFeedNotFound"
import ProductFeedSkeleton from "./ProductFeedSkeleton"

interface Props {
  config: BlockProductFeedEntityHydrated
  pageId: EntityId
}

const ProductFeedBlock: React.FC<Props> = ({ pageId, config }) => {
  const { id: blockId } = config
  const { href } = useLocation()

  useForceCanonicalForPage(pageId, href ?? "")
  useBootstrapProductFeed(blockId)
  const { productFeedBlock } = useProductFeedBlock(blockId)
  const { isReady = false, hasError = false } = productFeedBlock || {}

  let component = <ProductFeedSkeleton />
  if (hasError) {
    component = <ProductFeedNotFound />
  } else if (isReady) {
    component = <ProductFeedContent pageId={pageId} config={config} />
  }

  return (
    <Wrapper
      maxWidth="1000px"
      minHeight={{ base: "780px", md: "560px" }}
      borderBottomWidth={1}
    >
      {component}
    </Wrapper>
  )
}

export default ProductFeedBlock
